import { del, get, post, put } from '@/lib/api'
import type { Device, Session } from '@/types/models'

export type RegisterPayload = {
  business_name: string
  name: string
  email: string
  password: string
  password_confirmation: string
  phone?: string
  country_code?: string
  currency?: string
  timezone?: string
  plan_slug?: string
}

export type LoginPayload = {
  email: string
  password: string
  device_name?: string
}

export const authApi = {
  register: (payload: RegisterPayload) => post<Session>('/auth/register', payload),
  login: (payload: LoginPayload) => post<Session>('/auth/login', payload),
  me: () => get<Session>('/me'),

  forgotPassword: (email: string) =>
    post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (payload: {
    token: string
    email: string
    password: string
    password_confirmation: string
  }) => post<{ message: string }>('/auth/reset-password', payload),

  invitationPreview: (token: string) =>
    get<{ email: string; name: string; workspace: string; role: string | null; expires_at: string }>(
      `/auth/invitation/${token}`,
    ),

  acceptInvitation: (payload: {
    token: string
    name?: string
    password: string
    password_confirmation: string
  }) => post<Session>('/auth/accept-invitation', payload),

  devices: () => get<Device[]>('/auth/devices'),

  /** Revoke one token. The device holding it is signed out on its next call. */
  revokeDevice: (id: number) => del<{ message: string }>(`/auth/devices/${id}`),

  /**
   * Every token, including this one.
   *
   * The button somebody presses when a phone is lost, so it must not spare the
   * current session — signing out everywhere except here is not what the words
   * mean, and the till in the shop is exactly the device you cannot reach.
   */
  logoutAll: () => post<{ message: string }>('/auth/logout-all', {}),
  updateProfile: (payload: Record<string, unknown>) => put<Session>('/me', payload),
  updatePassword: (payload: Record<string, unknown>) =>
    put<{ message: string }>('/me/password', payload),
}
